import { all } from 'redux-saga/effects';

const telemedSagas = function* root() {
  yield all([]);
};
export { telemedSagas };
